"use client";

import "./UiUxHeroSection.scss";
import CTAButton from "@/components/CTAButton/CTAButtons";

import industry from "@/assets/icons/services/uiux/industry.svg";
import client from "@/assets/icons/services/uiux/client.svg";
import design from "@/assets/icons/services/uiux/design.svg";
import product from "@/assets/icons/services/uiux/product.svg";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";

import uiuxImg from "@/assets/images/services/uiux/uiuxdesign.webp";

const UiUxHeroSection = ({ hero }) => {
  const FLOATING_TAGS = [
    { id: 1, icon: industry, label: "20+ Industries Served ", bottom: "90%", right: "50%" },
    { id: 2, icon: client, label: "50+ Global clients ", top: "20%", left: "80%" },
    {
      id: 3,
      icon: design,
      label: "1000+ Creative Designs ",
      top: "70%",
      right: "70%",
    },
    {
      id: 4,
      icon: product,
      label: "180+ - Products launched ",
      top: "80%",
      left: "80%",
    },
    // { id: 5, icon: Chatbot, label: "AI Chatbot", top: "100%", left: "30%" },
  ];

  if (!hero) return null;

  const { title, description } = hero;

  return (
    <section className="uiux-hero-section">
      <Container className="uiux-hero-container">
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="uiux-hero-content">
              <h1>{title}</h1>
              <p>{description}</p>

              {/* CTA */}
              <CTAButton
                primaryText="Start your Project Now"
                secondaryText="Watch a Demo"
              />
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6}>
            <div className="hero-right">
              <div className="animation-wrapper">
                {/* Animated concentric rings */}
                <div className="ring ring-1"></div>
                <div className="ring ring-2"></div>
                <div className="ring ring-3"></div>
                <div className="ring ring-4"></div>

                {/* Floating feature tags */}
                {FLOATING_TAGS.map((tag) => (
                  <div
                    key={tag.id}
                    className="uiux-floating-tag"
                    style={{
                      top: tag.top,
                      bottom: tag.bottom,
                      left: tag.left,
                      right: tag.right,
                      animationDelay: `${tag.id * 0.4}s`,
                    }}
                  >
                    <div className="uiux-tag-dot">
                      <Image
                        src={tag.icon}
                        alt={tag.label}
                        width={18}
                        height={18}
                      />
                    </div>
                    <span>{tag.label}</span>
                  </div>
                ))}

                <div className="robot-img-wrapper">
                  <Image
                    src={uiuxImg}
                    alt="uiux-img"
                    className="robot-img"
                    width={420}
                    height={420}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UiUxHeroSection;
